var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayerNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentcolor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 10.863 2.5 1.385A1.5 1.5 0 0 0 0 2.521v18.958a1.5 1.5 0 0 0 2.5 1.136L13 13.137a1.54 1.54 0 0 0 0-2.274M17 0h7v24h-7z"
})));
export default SvgPlayerNext;